import { HeaderNavigationItem } from '@/components/Header/navigation';
import { classNames } from '@/utils/style/classNames';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

interface MobileMenuPrimaryNavigationProps {
  menu: HeaderNavigationItem[];
  onNavigate: () => void;
}

const MobileMenuPrimaryNavigation = ({ menu, onNavigate }: MobileMenuPrimaryNavigationProps) => {
  return (
    <div className="space-y-2 py-6">
      {menu.map((item) =>
        item.items ? (
          <Disclosure key={item.name} as="div" className="-mx-3">
            {({ open }) => (
              <>
                <DisclosureButton className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50">
                  <span>{item.name}</span>
                  <ChevronDownIcon
                    className={classNames(open ? 'rotate-180' : '', 'h-5 w-5 flex-none')}
                    aria-hidden="true"
                  />
                </DisclosureButton>
                <DisclosurePanel className="mt-2 space-y-2">
                  {(item.items || []).map((subItem) =>
                    subItem.href ? (
                      <Link
                        key={subItem.name}
                        to={subItem.href}
                        onClick={onNavigate}
                        className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      >
                        <span className="flex items-center gap-2">
                          {subItem.icon && (
                            <subItem.icon className="h-4 w-4 text-gray-400" aria-hidden="true" />
                          )}
                          {subItem.name}
                        </span>
                        <p className="mt-1 text-gray-600 text-xs font-normal">
                          {subItem.description}
                        </p>
                      </Link>
                    ) : (
                      <span key={subItem.name}>{subItem.name}</span>
                    ),
                  )}
                </DisclosurePanel>
              </>
            )}
          </Disclosure>
        ) : item.href ? (
          <Link
            key={item.name}
            to={item.href}
            onClick={onNavigate}
            className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
          >
            {item.name}
          </Link>
        ) : (
          <div key={item.name}>{item.name}</div>
        ),
      )}
    </div>
  );
};

export default MobileMenuPrimaryNavigation;
